import angular from 'angular';
import countrySelectorInput from './countrySelectorInput';
import './style.scss';

export default angular
  .module('components.countrySelectorInput', [])
  .component('countrySelectorInput', countrySelectorInput).name;
